/**
 * Runtime brand resolution.
 *
 * One build serves several product domains (app.boost.express,
 * app.mymatch.express, ...), so branding that differs per product is resolved
 * from the hostname at runtime. VITE_IS_OUTREACH_ENABLED remains the legacy
 * build-time flag for boostleads.ai and is not handled here.
 */

export const isMatchExpress = (): boolean =>
  /(^|\.)mymatch\.express$/i.test(window.location.hostname);

/**
 * The brand of the page being rendered, not of the domain. Off mymatch.express
 * the attendee views are reached by path (/login/attendee,
 * /registration/attendee), and a header keyed on the hostname alone would put
 * the Boost wordmark above a Match.Express form.
 */
export const isMatchExpressView = (pathname: string): boolean =>
  isMatchExpress() || pathname.includes('/attendee');
